import ModalPlayers from './ModalPlayers';

export default ModalPlayers;
